import InfiniteScrollComponent from 'react-infinite-scroll-component'
import { styled } from '../../../config'

export const StyledInfiniteScroll = styled(InfiniteScrollComponent, {})
